import axios from 'axios'
import { api } from '@/services/config'
import store from '@/store'
import { mixin } from '@/mixins/helper'

const mdDatabaseStore = {
  namespaced: true,
  state: () => ({
    is_loading: false,

    selectedTab: 'legal_doc',
    currentContent: 'kbli',

    kbliData: [],
    subKbliData: [],
    iujpData: [],
    iujptlData: [],
    sbujkData: [],
    inubbmData: [],
    siupalData: [],
    negaraData: [],
    provinsiData: [],
    kotaData: [],
    kecamatanData: [],
    kelurahanData: [],
    kategoriData: [],
    purposeData: [],
    bisnisUnitData: [],
    companyCodeData: [],
    nonIntiData: [],
    goldenRulesData: [],
    kbubData: [],
  }),
  mutations: {
    SET_LOADING(state, status) {
      state.is_loading = status
    },
    UPDATE_DATA(state, payload) {
      state[payload.name] = payload.value
    },
  },
  actions: {
    async onPageLoad({ commit, dispatch, rootState }, payload) {
      try {
        const activeSidebar = payload.value
        commit('UPDATE_DATA', payload)

        switch (activeSidebar) {
          case 'kbli':
            dispatch('getKbli')
            break
          case 'dkbli':
            dispatch('getDKbli')
            break
          case 'iujp':
            dispatch('getIujp')
            break
          case 'iujptl':
            dispatch('getIujptl')
            break
          case 'sbujk':
            dispatch('getSbujk')
            break
          case 'inu_bbm':
            dispatch('getInubbm')
            break
          case 'siupal':
            dispatch('getSiupal')
            break
          case 'negara':
            dispatch('getNegara')
            break
          case 'provinsi':
            dispatch('getProvinsi')
            break
          case 'kota':
            dispatch('getKota')
            break
          case 'kecamatan':
            dispatch('getKecamatan')
            break
          case 'kelurahan':
            dispatch('getKelurahan')
            break
          case 'kategori':
            dispatch('getKategori')
            break
          case 'tujuan_pendaftaran':
            dispatch('getTujuanPendaftaran')
            break
          case 'bisnis_unit':
            dispatch('getBisnisUnit')
            break
          case 'non_inti':
            dispatch('getNonInti')
            break
          case 'golden_rules':
            dispatch('getGoldenRules')
            break
          case 'kbub':
            dispatch('getKbub')
            break

          default:
            break
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getKbli({ commit, state }) {
      try {
        const url = `${api}/api/v1/kbli-parent?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'kbliData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getDKbli({ commit, state }) {
      try {
        const url = `${api}/api/v1/kbli-sub?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'subKbliData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getIujp({ commit, state }) {
      try {
        const url = `${api}/api/v1/iujp?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'iujpData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getIujptl({ commit, state }) {
      try {
        const url = `${api}/api/v1/iujptl?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'iujptlData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getSbujk({ commit, state }) {
      try {
        const url = `${api}/api/v1/sbujk?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'sbujkData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getInubbm({ commit, state }) {
      try {
        const url = `${api}/api/v1/inu-bbm?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'inubbmData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getSiupal({ commit, state }) {
      try {
        const url = `${api}/api/v1/siupal?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'siupalData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getNegara({ commit, state }) {
      try {
        const url = `${api}/api/v1/negara?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'negaraData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getProvinsi({ commit, state }) {
      try {
        const url = `${api}/api/v1/provinsi?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'provinsiData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getKota({ commit, state }) {
      try {
        const url = `${api}/api/v1/kota?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'kotaData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getKecamatan({ commit, state }) {
      try {
        const url = `${api}/api/v1/kecamatan?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'kecamatanData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getKelurahan({ commit, state }) {
      try {
        const url = `${api}/api/v1/kelurahan?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'kelurahanData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getKategori({ commit, state }) {
      try {
        const url = `${api}/api/v1/m-ticket-category?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'kategoriData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getTujuanPendaftaran({ commit, state }) {
      try {
        const url = `${api}/api/v1/m-purpose-ticket?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'purposeData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getBisnisUnit({ commit, state }) {
      try {
        const url = `${api}/api/v1/m-bisnis-unit?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'bisnisUnitData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getCompanyCode({ commit, state }, params) {
      try {
        const url = `${api}/api/v1/m-company-code?${params}&page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'companyCodeData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })

          return data.data
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getNonInti({ commit, state }) {
      try {
        const url = `${api}/api/v1/perizinan-non-inti?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'nonIntiData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getGoldenRules({ commit, state }) {
      try {
        const url = `${api}/api/v1/golden-rules?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'goldenRulesData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async getKbub({ commit, state }) {
      try {
        const url = `${api}/api/v1/m-kbub?page=1&limit=2000`
        await commit('SET_GLOBAL_LOADING', true, { root: true })

        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.status == 'success') {
          commit('UPDATE_DATA', {
            name: 'kbubData',
            value: data.data,
          })
          await commit('SET_GLOBAL_LOADING', false, { root: true })
        }
      } catch (err) {
        commit('UPDATE_DATA', {
          name: 'kbubData',
          value: [],
        })
        await await commit(
          'SET_NOTIF',
          mixin.methods.$get(err, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
  },
}

export default mdDatabaseStore
